<template>
    <v-menu v-model="menu">
        <template v-slot:activator="{ on, attrs }">
            <v-autocomplete
                    color="primary"
                    hide-no-data
                    v-model="organizationSelected"
                    :clearable="!unclearable"
                    :items="organizationsSelected"
                    :loading="organizationLoading"
                    :search-input.sync="organizationSearch"
                    item-text="name"
                    item-value="id"
                    :label="noLabel ? '' : $t('SmsPushSetting.TableTitle.organization')"
                    :error-messages="errorMessages"
                    return-object
                    v-bind="attrs"
                    v-on="on"
            >
                <template v-slot:append>
                    <v-icon
                            style="height: 24px; width: 24px"
                            :color="menu ? 'primary' : ''"
                            @click.stop="menu = !menu"
                    >
                        {{ menu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                </template>
            </v-autocomplete>
        </template>
        <div style="max-height: 304px">
            <v-sheet>
                <v-treeview
                        v-model="tree"
                        :items="organization"
                        :search="organizationSearch"
                        :filter="organizationFilter"
                        :active.sync="organizationsSelected"
                        item-key="id"
                        item-children="organizations"
                        open-all
                        hoverable
                        activatable
                        return-object
                />
            </v-sheet>
        </div>
    </v-menu>
</template>

<style scoped>
    .v-list {
        display: none !important;
    }
    .v-menu__content {
        margin-top: 45px;
    }
</style>

<script>
import organization from "@/api/organizations";

export default {
    name: "SearcherOrganization",

    props: {
        value: Object,
        noLabel: Boolean,
        unclearable: Boolean,
        errorMessages: Array,
    },

    computed: {
        organizationFilter() {
            return (item, search, textKey) =>
                this.organizationSelected &&
                search == this.organizationSelected.name
                    ? true
                    : item[textKey].indexOf(search) > -1;
        },
    },

    created() {
        this.getorganizationFromAPI();
    },

    data: () => ({
        menu: false,
        tree: [],
        organization: [],
        organizationLoading: false,
        organizationSearch: "",
        organizationsSelected: [],
        organizationSelected: null,
    }),

    methods: {
        getorganizationFromAPI() {
            this.organizationLoading = true;
            organization.tree()
                .then(
                    function (response) {
                        if (response.data.status.isOK()) {
                            this.organization = response.data.organizations;
                        }
                        this.organizationLoading = false;
                    }.bind(this)
                )
                .catch(
                    function () {
                        this.organizationLoading = false;
                    }.bind(this)
                );
        },
    },

    watch: {
        value: {
            immediate: true, //初始赋值也调用
            handler() {
                this.organizationsSelected = this.value ? [this.value] : [];
            },
        },
        organizationsSelected: {
            immediate: true, //初始赋值也调用
            handler() {
                this.organizationSelected =
                    this.organizationsSelected && this.organizationsSelected[0]
                        ? this.organizationsSelected[0]
                        : null;
            },
        },
        organizationSelected: {
            handler() {
                this.organizationsSelected = this.organizationSelected
                    ? [this.organizationSelected]
                    : [];
                this.$emit("input", this.organizationSelected);
            },
        },
        organizationSearch: {
            handler() {
                if (!this.unclearable && !this.organizationSearch)
                    this.organizationsSelected = [];
            },
        },
    },
};
</script>
